import * as DataFieldHelper from './DataFieldHelper';
import { DataField } from './DataField';

export function getFieldsForContract(instanceName: string, contractName: string, contractFields: DataField[]) {
  let dataFields: DataField[] = contractFields.map(
    (contractField): DataField => {
      return {
        name: `${instanceName}.${contractField.name}`,
        value: contractField.value,
        dataType: contractField.dataType
      } as DataField;
    }
  );

  addContractField(dataFields, instanceName, contractName);
  return dataFields;
}

export function addContractField(dataFields: DataField[], instanceName: string, contractName: string): void {
  dataFields.push(DataFieldHelper.makeStringDataField(`zC.${instanceName}`, contractName));
}
